// new CustomEvent('build', { bubble, cancelable, composed, detail: {...} })

// Require support of CustomEvent / initCustomEvent
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
// https://github.com/theftprevention/event-constructor-polyfill
// // https://github.com/webcomponents/webcomponents-platform/blob/02ae88f96193f71e47e5593f1bc465c8a4751122/webcomponents-platform.js#L44-L105
if(typeof window.CustomEvent !== "function" ){
  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
}
